import React from 'react';

import { useCurrentUser } from 'Auth';

import { Section } from '@gogame/components';
import { FormField } from '@gogame/form';
import { useMountedState } from '@gogame/hooks-ts';

import { loadUsers } from 'scenes/SmartRules/sources/fields';

import { NOTIFICATIONS } from './constants';

export const Notifications = ({ owner }) => {
  const [usersList, setUsersList] = useMountedState(null);

  const currentUser = useCurrentUser();

  const loadUsersList = async () => {
    const response = await loadUsers();
    setUsersList(response);
  };

  React.useEffect(() => {
    loadUsersList();
  }, []);

  const handleSearchUsers = React.useCallback(
    ({ search }) => {
      return Promise.resolve(
        usersList?.filter(({ name, login, email }) => {
          const nameLowerCase = [name, login, email]
            .map((el) => el.toString())
            .join(' ');
          const searchLowerCase = search.toLowerCase();
          return nameLowerCase.includes(searchLowerCase);
        }) || []
      );
    },
    [usersList]
  );

  return (
    <Section title={'Notifications'}>
      <FormField.ChipsInput
        label={'Email recipients'}
        name={NOTIFICATIONS}
        onSearch={handleSearchUsers}
        required={true}
        padding={0}
        isTagRemovable={(opt) => {
          return opt.userId !== currentUser.id && opt.userId !== owner?.userId;
        }}
      />
    </Section>
  );
};
